import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
const DBS = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("dbs"))
    .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
        question: "What are the forex markup charges on DBS credit cards?",
        answer:
          "DBS cards offer competitive forex markups starting from 2.5%, making them suitable for international travelers.",
      },
      {
        question: "Are there any lifetime free credit cards from DBS Bank?",
        answer:
          "Yes, certain introductory offers and partnerships include lifetime free variants, especially for existing DBS DigiSavings users.",
      },
      {
        question: "Can I manage my DBS credit card through a mobile app?",
        answer:
          "Absolutely! DBS offers a user-friendly mobile app that lets you track spends, redeem rewards, set limits, and make payments instantly.",
      },
      {
        question: "How long does it take to receive a DBS credit card after approval?",
        answer:
          "Once approved, your card is dispatched within 5–7 working days to your registered address.",
      },
      {
        question: "Is it necessary to have a DBS bank account to apply for their credit card?",
        answer:
          "No, it’s not mandatory. However, existing account holders may enjoy faster approval and additional relationship-based offers.",
      },
    ];

  const steps = [
    {
        icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
        title: "Verify Eligibility Criteria",
        description:
          "Ensure you meet the card’s specific requirements regarding income, credit score, and city availability to avoid application rejections.",
      },
    {
        icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
        title: "Apply via Official DBS Website",
        description:
          "Click on the “Apply Now” button to be redirected to the official DBS Bank portal, where you can complete the application securely online.",
      },
  
   
      {
        icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
        title: "Prepare Your Documents",
        description:
          "Gather ID proofs, address documents, income papers, and PAN card to fast-track the application process.",
      },
      {
        icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
        title: "Explore & Compare with TheFinMaster",
        description:
          "Browse through our expertly curated list of DBS Bank credit cards on TheFinMaster. Each listing includes detailed benefits, reward mechanics, fees, and user suitability—helping you make an informed choice that matches your lifestyle.",
      },
    ];
  return (
    <>
      <Helmet>
        <title>
          Get Bank of Baroda (BOB) Credit Card 2024 - Compare &amp; Apply Online
          at TheFinmaster
        </title>
        <meta
          name="description"
          content="Bank of Baroda Credit Cards - Check all types of Bank of Baroda bank credit cards list &amp; their benefits to select the right card for you. Apply for top &amp; best Bank of Baroda credit card now. | TheFinmaster"
        />
        <meta
          name="keywords"
          content="abank of baroda lifetime free credit card, bob easy credit card apply, bank of baroda hpcl credit card, bank of baroda snapdeal credit card, bobcard payment"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/dbs-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 mt-10">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Effortless, Rewarding, and Digital-First Credit Cards
            </h2>
            <p className="text-gray-600 leading-relaxed mt-3">
              DBS Bank India brings the power of digital banking to your wallet with a select range of credit cards that combine global privileges, strong reward ecosystems, and smart spending insights. Known for their mobile-first approach and seamless banking experience, DBS credit cards are ideal for urban professionals, frequent travelers, and digital natives who value control, transparency, and value-packed features—all with the trust of one of Asia’s most reputed financial institutions.
            </p>
          </div>
        </div>
        <h1 className="text-center text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                     key={index}
                     cardDetails={item}
                     Card_features={item?.Card_features}
                     fees={item?.fees}
                     cardName={item?.title}
                     cardImage={item?.image}
                     rating={item?.rating}
                     category={item?.category}
                     status={item?.status}
                     bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

           <div className="w-full relative ">
                            <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                              {/* <div className="w-[70%] mx-auto">
                                                         <h2 className="text-center font-medium pt-5 text-lg">
                                                           <span className="font-semibold text-white">816 people</span>{" "}
                                                           are on call with our advisors right now
                                                         </h2>
                                                       </div> */}
                              <div className="w-full mx-auto">
                                <Link
                                  to="https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <div className="w-[80%] mx-auto ">
                                    <img src="/assets/ppp.png" alt="Advertisement" />
                                  </div>
                                </Link>
                                <div className="bg-white">
                                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                             Know your advisor
                                                           </h3> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

       

        {/* <div className='w-[95%] py-10'>
                                         <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                                         <AccordionComponent />
                                     </div> */}

        <div className="w-full px-2 py-10 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                Eligibility Criteria to Apply for DBS Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    You must be between 21 to 60 years old to apply for a primary DBS credit card. For add-on cards, the minimum age is 18 years.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income Requirement
                  </span>
                  <span>
                    Salaried applicants must have a monthly income of at least ₹25,000–₹30,000, depending on the card variant. Self-employed applicants should furnish valid ITRs showing stable earnings.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score Requirement
                  </span>
                  <span>
                    A minimum CIBIL score of 700 is preferred for approval. Clean repayment history strengthens eligibility.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Status
                  </span>
                  <span>
                    Both salaried employees and self-employed individuals are eligible. Employment stability is a key criterion for approval.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    City/Location Eligibility
                  </span>
                  <span>
                    Credit cards are currently available in major Indian metros and Tier-1 cities. Availability may vary based on service zones.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for DBS Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                    Identity Proof
                  </span>
                  <span>
                    Acceptable IDs include Aadhaar Card, Passport, PAN Card, or Driving License for verification purposes.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Address Proof
                  </span>
                  <span>
                    Provide recent utility bills, Aadhaar card, passport, or bank statements with your current residential address.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Documents
                  </span>
                  <span>
                    Salaried: Last 3 months’ salary slips or bank salary credits + Form 16. Self-employed: Latest ITR, GST returns, and bank statements.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card
                  </span>
                  <span>
                    Mandatory for credit evaluation and to comply with RBI's KYC guidelines.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Photograph
                  </span>
                  <span>
                    A recent passport-sized photograph may be required during the onboarding process.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
        How to Apply for DBS Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
                                   Applying for a fuel credit card is a seamless process that starts with
                                   the right research and ends at the official bank’s platform for final
                                   submission. Here’s how you can get started through TheFinMaster.com:
                                 </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DBS;
